import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import apiClient from '../lib/apiClient';
import Ranking from './Ranking';

class Private extends Component {
	constructor() {
		super();
		this.state = {
			place: "",
			day: "",
			availableSongs: [],
			chosenSongs: [],
			ongoingGig: false,
			isLoading: true
		}
	}

	async componentDidMount() {
		const availableSongs = await apiClient.getAllSongs();
		const currentGig = await apiClient.getGig();
		if (currentGig) {
			if (currentGig.ongoing) {
				return this.setState({ ongoingGig: true, place: currentGig.place, day: currentGig.day, isLoading: false })
			}
		}
			return this.setState({ availableSongs, ongoingGig: false, isLoading: false });
	}

	endGig = async () => {
		await apiClient.endGig();
		location.reload();
	}

	render() {
		const { place, day, ongoingGig, isLoading } = this.state;
		
		if (isLoading) {
			return <div className="main h-2/3">loading ... </div>;
		}

		return (
			<div className="main h-auto min-h-full pt-20 text-center">
				{!ongoingGig ?
					<div className="flex h-1/3 flex-col justify-evenly items-center pt-10">
						<Link to="/gig"><button className="button mb-5">Nova actuació</button></Link>
						<br />
						<Link to="/repertoire"><button className="button mb-5">Repertori</button></Link>
					</div>
						:
					<div className="text-left pl-10">
					<p className="text-2xl">Actuació en marxa!</p>
						<p className="pb-5">{place} | {day}</p>
						<Ranking />
						<div className="mt-5">
							<button className="button" onClick={this.endGig}>Finalitza actuació</button>
						</div>
					</div>
				}
				<br />
				
			</div>
		);
	}
}

export default Private;
